(() => {
  "use strict";
  const mobile = window.matchMedia("(max-width: 800px)");
  const setPanels = () => document.querySelectorAll("[data-nl-filter-panel]").forEach(panel => {
    panel.open = !mobile.matches || window.location.hash === "#marki";
  });
  setPanels();
  if (mobile.addEventListener) mobile.addEventListener("change", setPanels);
  document.addEventListener("shopify:section:load", setPanels);
  window.addEventListener("hashchange", () => {
    if (window.location.hash === "#marki") {
      const brands = document.getElementById("marki");
      const panel = brands && brands.closest("details");
      if (panel) panel.open = true;
    }
  });
  document.addEventListener("submit", async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches("[data-nl-quick-add]") || !window.fetch) return;
    event.preventDefault();
    const button = form.querySelector("button");
    const status = form.querySelector("[role=status]");
    if (!button || button.disabled) return;
    const original = button.innerHTML;
    button.disabled = true;
    button.textContent = "Dodawanie…";
    if (status) status.textContent = "";
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    const prefix = root.endsWith("/") ? root : root + "/";
    try {
      const result = await fetch(prefix + "cart/add.js", {method:"POST",body:new FormData(form),credentials:"same-origin",headers:{"Accept":"application/json"}});
      const data = await result.json();
      if (!result.ok) throw new Error(data.description || data.message || "Nie udało się dodać produktu.");
      const current = await fetch(prefix + "cart.js", {credentials:"same-origin"});
      if (current.ok) {
        const cart = await current.json();
        document.querySelectorAll("[data-cart-count]").forEach(node => { node.textContent = String(cart.item_count); });
        document.querySelectorAll(".nl-cart-link").forEach(node => { node.setAttribute("aria-label", "Koszyk — " + cart.item_count + " produktów"); });
      }
      if (status) status.textContent = "Dodano do koszyka.";
      button.textContent = "Dodano ✓";
      const toast = document.querySelector("[data-toast]");
      if (toast) {
        const text = document.createElement("span");
        text.textContent = "Produkt dodany do koszyka. ";
        const link = document.createElement("a");
        link.href = prefix + "cart";
        link.textContent = "Otwórz koszyk →";
        toast.replaceChildren(text, link);
        toast.hidden = false;
        clearTimeout(toast._hideTimer);
        toast._hideTimer = setTimeout(() => { toast.hidden = true; }, 6000);
      }
    } catch (error) {
      if (status) status.textContent = error.message || "Sprawdź dostępność na karcie produktu.";
    } finally {
      setTimeout(() => { button.innerHTML = original; button.disabled = false; }, 1400);
    }
  });
})();
